import { ICampaign } from '../models';

export function fromJsonApi(data, included: any[]): ICampaign {
  return {
    id: data.id,
    name: data.attributes.name,
    code: data.attributes.code,
    status: data.attributes.status,
    metadata: {
      prevent_mta_upsell: data.attributes?.metadata?.prevent_mta_upsell,
      prevent_mta_tier_change: data.attributes?.metadata?.prevent_mta_tier_change,
      prevent_display: data.attributes?.metadata?.prevent_display,
    },
    regex_voucher_code: data.attributes.regex_voucher_code,
    discount: data.attributes.discount,
  };
}
